export default function parseDate(dateStr) {
  if (dateStr) {
    const date = new Date(dateStr);
    if (dateStr.indexOf('Z') === -1) {
      // Not a UTC but a local date/time
      date.setUTCMinutes(date.getUTCMinutes() + date.getTimezoneOffset());
    }
    return date;
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/shared/parseDate.js